
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';

import UserList from '../components/user/List';
import UserCreate from '../components/user/Create';
import UserUpdate from '../components/user/Update';
import UserShow from '../components/user/Show';

import AudioList from '../components/audio/List';
import AudioCreate from '../components/audio/Create';
import AudioUpdate from '../components/audio/Update';
import AudioShow from '../components/audio/Show';

import TestimonialList from '../components/testimonial/List';
import TestimonialCreate from '../components/testimonial/Create';
import TestimonialUpdate from '../components/testimonial/Update';
import TestimonialShow from '../components/testimonial/Show';

import VideoList from '../components/video/List';
import VideoCreate from '../components/video/Create';
import VideoUpdate from '../components/video/Update';
import VideoShow from '../components/video/Show';

import MediaObjectList from '../components/mediaobject/List';
import MediaObjectCreate from '../components/mediaobject/Create';
import MediaObjectUpdate from '../components/mediaobject/Update';
import MediaObjectShow from '../components/mediaobject/Show';

import SpeakerList from '../components/speaker/List';
import SpeakerCreate from '../components/speaker/Create';
import SpeakerUpdate from '../components/speaker/Update';
import SpeakerShow from '../components/speaker/Show';

import InfoList from '../components/info/List';
import InfoCreate from '../components/info/Create';
import InfoUpdate from '../components/info/Update';
import InfoShow from '../components/info/Show';

import Login from '../components/auth/Login';
import Dashboard from '../components/dashboard/Dashboard';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {  
  // console.log("ifNotAuthenticated:",store.getters["auth/isAuthenticated"]);
  if (!store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next('/');
}

const ifAuthenticated = (to, from, next) => {
  // console.log("ifAuthenticated:",store.getters["auth/isAuthenticated"]);
  if (store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next('/login');
}

const routes = [   
    // { name: 'UserList', path: '/users/', component: UserList , beforeEnter: ifAuthenticated },
    // { name: 'UserCreate', path: '/users/create', component: UserCreate , beforeEnter: ifAuthenticated },
    // { name: 'UserUpdate', path: '/users/edit/:id', component: UserUpdate , beforeEnter: ifAuthenticated },
    // { name: 'UserShow', path: '/users/show/:id', component: UserShow , beforeEnter: ifAuthenticated },
  
    { name: 'AudioList', path: '/audio/', component: AudioList , beforeEnter: ifAuthenticated },
    { name: 'AudioCreate', path: '/audio/create', component: AudioCreate , beforeEnter: ifAuthenticated },
    { name: 'AudioUpdate', path: '/audio/edit/:id', component: AudioUpdate , beforeEnter: ifAuthenticated },
    { name: 'AudioShow', path: '/audio/show/:id', component: AudioShow , beforeEnter: ifAuthenticated },

    { name: 'VideoList', path: '/videos/', component: VideoList , beforeEnter: ifAuthenticated },
    { name: 'VideoCreate', path: '/videos/create', component: VideoCreate , beforeEnter: ifAuthenticated },
    { name: 'VideoUpdate', path: '/videos/edit/:id', component: VideoUpdate , beforeEnter: ifAuthenticated },
    { name: 'VideoShow', path: '/videos/show/:id', component: VideoShow , beforeEnter: ifAuthenticated },

    { name: 'TestimonialList', path: '/testimonials/', component: TestimonialList , beforeEnter: ifAuthenticated },
    { name: 'TestimonialListAudio', path: '/testimonials?audio=:id', component: TestimonialList , beforeEnter: ifAuthenticated },
    { name: 'TestimonialListVideo', path: '/testimonials?video=:id', component: TestimonialList , beforeEnter: ifAuthenticated },
    { name: 'TestimonialCreate', path: '/testimonials/create', component: TestimonialCreate , beforeEnter: ifAuthenticated },
    { name: 'TestimonialUpdate', path: '/testimonials/edit/:id', component: TestimonialUpdate , beforeEnter: ifAuthenticated },
    { name: 'TestimonialShow', path: '/testimonials/show/:id', component: TestimonialShow , beforeEnter: ifAuthenticated },

    // { name: 'MediaObjectList', path: '/media-objects/', component: MediaObjectList , beforeEnter: ifAuthenticated },
    // { name: 'MediaObjectCreate', path: '/media-objects/create', component: MediaObjectCreate , beforeEnter: ifAuthenticated },
    // { name: 'MediaObjectUpdate', path: '/media-objects/edit/:id', component: MediaObjectUpdate , beforeEnter: ifAuthenticated },
    // { name: 'MediaObjectShow', path: '/media-objects/show/:id', component: MediaObjectShow , beforeEnter: ifAuthenticated },

    { name: 'SpeakerList', path: '/speakers/', component: SpeakerList , beforeEnter: ifAuthenticated },
    { name: 'SpeakerCreate', path: '/speakers/create', component: SpeakerCreate , beforeEnter: ifAuthenticated },
    { name: 'SpeakerUpdate', path: '/speakers/edit/:id', component: SpeakerUpdate , beforeEnter: ifAuthenticated },
    { name: 'SpeakerShow', path: '/speakers/show/:id', component: SpeakerShow , beforeEnter: ifAuthenticated },

    { name: 'InfoList', path: '/infos/', component: InfoList , beforeEnter: ifAuthenticated },
    { name: 'InfoCreate', path: '/infos/create', component: InfoCreate , beforeEnter: ifAuthenticated },
    { name: 'InfoUpdate', path: '/infos/edit/:id', component: InfoUpdate , beforeEnter: ifAuthenticated },
    { name: 'InfoShow', path: '/infos/show/:id', component: InfoShow , beforeEnter: ifAuthenticated },
  
    { name: 'Login', path: '/login', component: Login, beforeEnter: ifNotAuthenticated },
    { name: 'Dashboard', path: '/', component: Dashboard, beforeEnter: ifAuthenticated },
    

  ];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;


// WEBPACK FOOTER //
// ./src/router/router.js